// extracted by mini-css-extract-plugin
export default {"table-container":"SwEqeNa3ATS0m88lJVsX","table-top-right-field":"FSV2tisNubfzjqY1m1_H","divider":"BwwS99KCG1FqrGN5HijF","table":"WU1dv_wkbrkBVmFtvgkV"};